import { motion } from 'framer-motion';
import { Button } from '@/components/ui/button';
import { Crown, ArrowRight, Phone, Calendar, MessageCircle } from 'lucide-react';
import { Link } from 'react-router-dom';

const VIPConsultationBanner = () => {
  const openWhatsApp = () => {
    const message = encodeURIComponent(
      "Hello, I'm interested in a private consultation regarding luxury real estate investment. Please contact me at your earliest convenience."
    );
    window.open(`https://wa.me/37060044499?text=${message}`, '_blank');
  };

  return (
    <section className="py-16 lg:py-20 bg-gradient-to-r from-gold/5 via-gold/10 to-gold/5 border-y border-gold/20">
      <div className="container mx-auto px-6 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="flex flex-col lg:flex-row items-center justify-between gap-8"
        >
          {/* Left - Message */}
          <div className="flex items-center gap-6 text-center lg:text-left">
            <div className="hidden lg:flex w-16 h-16 rounded-full bg-gradient-gold items-center justify-center flex-shrink-0">
              <Crown className="h-8 w-8 text-cream" />
            </div>
            <div>
              <h3 className="font-display text-2xl md:text-3xl text-foreground mb-2">
                Ready for a Private Consultation?
              </h3>
              <p className="text-muted-foreground max-w-lg">
                Speak directly with a senior advisor about your investment objectives. 
                No obligation, complete discretion.
              </p>
            </div>
          </div>

          {/* Right - Actions */}
          <div className="flex flex-col sm:flex-row items-center gap-3">
            <Button
              variant="luxury"
              size="lg"
              className="w-full sm:w-auto"
              onClick={openWhatsApp}
            >
              <MessageCircle className="h-5 w-5 mr-2" />
              WhatsApp Now
            </Button>
            
            <Button
              variant="outline"
              size="lg"
              className="w-full sm:w-auto border-gold/50 text-gold hover:bg-gold/10"
              asChild
            >
              <a href="tel:+37060044499">
                <Phone className="h-5 w-5 mr-2" />
                Call Direct
              </a>
            </Button>

            <Button
              variant="ghost"
              size="lg"
              className="w-full sm:w-auto text-foreground hover:text-gold"
              asChild
            >
              <Link to="/#contact">
                <Calendar className="h-5 w-5 mr-2" />
                Schedule
                <ArrowRight className="h-4 w-4 ml-2" />
              </Link>
            </Button>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default VIPConsultationBanner;
